import { forwardRef, type ButtonHTMLAttributes } from "react";

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: "primary" | "ghost";
};

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(function Button(
  { className = "", variant = "primary", type = "button", ...rest },
  ref,
) {
  const base =
    "inline-flex items-center justify-center rounded-md px-5 py-2.5 text-[calc(0.875rem+0.05vw)] font-medium transition-colors duration-200 disabled:opacity-50";
  const ring =
    "focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-accent";
  const styles =
    variant === "primary"
      ? "border border-border-strong bg-accent text-canvas hover:bg-ink hover:text-canvas"
      : "border border-border bg-transparent text-ink hover:border-border-strong hover:text-accent";
  return <button ref={ref} type={type} className={`${base} ${ring} ${styles} ${className}`.trim()} {...rest} />;
});
